import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      domesticSearch: {
        TAX_CODE: 'Tax Code',
        PHONE: 'Phone',
        REGISTERED_ADDRESS: 'Registered Address',
        INDUSTRY: 'Industry',
        LEGAL_FORM: 'Legal Form',
        STATUS: 'Status',
        LOCATION_TYPE: 'Location type',
        RESET: 'Reset',
        CANT_FIND_BUSINESS:
          'Want to find companies that meet certain criteria?',
        TRY_SCREENING: 'Try Screening',
        RESULTS: 'results',
        RESULT: 'result',
        FOR_COMPANY: 'for company',
        HEADQUARTERS: 'Headquarters',
        HEADQUARTER_TOOLTIP_INFO:
          'To exclude branches, business location and representative offices from the company list.',
        OTHERS: 'Others',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      domesticSearch: {
        TAX_CODE: 'Mã Số Thuế',
        PHONE: 'Số Điện Thoại',
        REGISTERED_ADDRESS: 'Địa Chỉ Đăng Ký',
        INDUSTRY: 'Ngành',
        LEGAL_FORM: 'Loại Hình Kinh Doanh',
        STATUS: 'Trạng thái',
        LOCATION_TYPE: 'Loại vị trí',
        RESET: 'Đặt lại',
        CANT_FIND_BUSINESS: 'Cần tìm kiếm các công ty theo điều kiện cụ thể?',
        TRY_SCREENING: 'Dùng Sàng lọc tự động',
        RESULTS: 'kết quả',
        RESULT: 'kết quả',
        FOR_COMPANY: 'cho công ty',
        HEADQUARTERS: 'Trụ sở chính',
        HEADQUARTER_TOOLTIP_INFO:
          'Để lọc ra danh các công ty không bao gồm chi nhánh, văn phòng đại diện, địa điểm kinh doanh',
        OTHERS: 'Khác',
      },
    },
  }),
)
